export function speakerForSegment(segment, index) {
  return segment.speaker || `SPEAKER_${index}`;
}

export function filterSegmentsBySpeaker(segments, activeSpeaker) {
  return (segments || [])
    .map((segment, index) => ({ segment, originalIndex: index }))
    .filter(({ segment, originalIndex }) => {
      if (!activeSpeaker) return true;
      return speakerForSegment(segment, originalIndex) === activeSpeaker;
    });
}

export function rebuildTranscription(segments) {
  return (segments || [])
    .map((segment, index) => {
      const text = (segment.text || '').trim();
      if (!text) return '';
      const speaker = speakerForSegment(segment, index);
      return speaker ? `${speaker}: ${text}` : text;
    })
    .filter(Boolean)
    .join('\n');
}

/**
 * Groups already speaker-filtered items into runs of consecutive segments
 * with the same speaker.
 *
 * Input shape (matches the output of filterSegmentsBySpeaker):
 *   [{ segment, originalIndex }, ...]
 *
 * Output: [{ speaker, items: [{segment, originalIndex}, ...], start, end }, ...]
 *
 * Notes:
 * - Grouping is only applied to *directly consecutive* segments. Non-adjacent
 *   runs of the same speaker form separate blocks (correct, because they're
 *   not consecutive in the source transcript).
 * - Empty input yields an empty array.
 */
export function groupConsecutiveBySpeaker(filteredSegments) {
  const blocks = [];
  for (const item of filteredSegments || []) {
    const { segment, originalIndex } = item;
    const speaker = speakerForSegment(segment, originalIndex);
    const last = blocks[blocks.length - 1];
    if (last && last.speaker === speaker) {
      last.items.push(item);
      if (typeof segment.end === 'number') last.end = segment.end;
    } else {
      blocks.push({
        speaker,
        items: [item],
        start: segment.start,
        end: segment.end,
      });
    }
  }
  return blocks;
}
